'use client';

import { useToastStore } from '@/stores/toast.store';

/**
 * Consumer entry point for firing toasts (design-system `useToast()` API).
 * Thin wrapper over the global toast store so components don't import it directly.
 */
export function useToast() {
  const showToast = useToastStore((s) => s.showToast);
  const showSuccess = useToastStore((s) => s.showSuccess);
  const showInfo = useToastStore((s) => s.showInfo);
  const showError = useToastStore((s) => s.showError);
  const dismiss = useToastStore((s) => s.dismissToast);

  return { showToast, showSuccess, showInfo, showError, dismiss };
}
